

angular
.module('inkfinder')
.factory('ScheduleUtilFactory', function ScheduleUtilFactory(
  moment,
  _
) {
  ScheduleUtilFactory.booleansToDays = booleansToDays;
  ScheduleUtilFactory.daysToText = daysToText;
  ScheduleUtilFactory.daysToBoolean = daysToBoolean;
  ScheduleUtilFactory.getApplicableRules = getApplicableRules;
  ScheduleUtilFactory.groupByDay = groupByDay;
  ScheduleUtilFactory.getShopTimes = getShopTimes;
  ScheduleUtilFactory.generateRuleInstances = generateRuleInstances;
  ScheduleUtilFactory.getRulesInRange = getRulesInRange;
  ScheduleUtilFactory.mergeConsecutive = mergeConsecutive;
  ScheduleUtilFactory.calculateDuration = calculateDuration;
  ScheduleUtilFactory.filterByDuration = filterByDuration;
  ScheduleUtilFactory.sort = sort;
  ScheduleUtilFactory.filterExceptions = filterExceptions;

  // Day-of-week object constants
  let sunday = {id: 0, name: 'Sunday'};
  let monday = {id: 1, name: 'Monday'};
  let tuesday = {id: 2, name: 'Tuesday'};
  let wednesday = {id: 3, name: 'Wednesday'};
  let thursday = {id: 4, name: 'Thursday'};
  let friday = {id: 5, name: 'Friday'};
  let saturday = {id: 6, name: 'Saturday'};

  ScheduleUtilFactory.daysArray = [
    sunday,
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday];
  ScheduleUtilFactory.days = {
    sunday: sunday,
    monday: monday,
    tuesday: tuesday,
    wednesday: wednesday,
    thursday: thursday,
    friday: friday,
    saturday: saturday};

  /**
   * @name booleansToDays
   * @description description
   * @param {type} rule Description
   */
  function booleansToDays(rule) {
    rule.days = [];
    if (rule.is_sunday) {
      rule.days.push(sunday);
    }
    if (rule.is_monday) {
      rule.days.push(monday);
    }
    if (rule.is_tuesday) {
      rule.days.push(tuesday);
    }
    if (rule.is_wednesday) {
      rule.days.push(wednesday);
    }
    if (rule.is_thursday) {
      rule.days.push(thursday);
    }
    if (rule.is_friday) {
      rule.days.push(friday);
    }
    if (rule.is_saturday) {
      rule.days.push(saturday);
    }
    rule.selected_days = rule.days;
    // See where we need selected_days vs days
  }

  /**
   * @name daysToText
   * @description description
   * @param {type} rule Description
   */
  function daysToText(rule) {
    let text = '';
    let daysOfWeek = '';
    let days = rule.selected_days;
    let dayCount = days.length;
    if (!days.length) {
      return;
    }
    for (let i = 0; i < days.length; i++) {
      daysOfWeek += days[i].name;
      if (i < dayCount - 2) {
        daysOfWeek += ', ';
      } else if (i === dayCount - 2) {
        daysOfWeek += ' and ';
      }
    }
    if (dayCount === 7) {
      text = 'every day';
    } else if (dayCount === 5 && days.indexOf(saturday) ===
    -1 && days.indexOf(sunday) === -1) {
      text = 'weekdays';
    } else if (dayCount === 2 && days.indexOf(saturday) >=
    0 && days.indexOf(sunday) >= 0) {
      text = 'weekends';
    } else {
      text += daysOfWeek;
    }

    if (rule.weekly_frequency === 1) {
      text += ' of every week';
    }
    if (rule.weekly_frequency === 2) {
      text += ' of every other week';
    }

    rule.text = text;
    rule.daysOfWeek = daysOfWeek;
  }

  /**
   * @name daysToBoolean
   * @description description
   * @param {type} rule Description
   */
  function daysToBoolean(rule) {
    for (let i = 0; i < rule.selectedDays.length; i++) {
      let selectedDay = rule.selectedDays[i];
      if (selectedDay.id === 1) {
        rule.is_sunday = true;
      }
      if (selectedDay.id === 2) {
        rule.is_monday = true;
      }
      if (selectedDay.id === 3) {
        rule.is_tuesday = true;
      }
      if (selectedDay.id === 4) {
        rule.is_wednesday = true;
      }
      if (selectedDay.id === 5) {
        rule.is_thursday = true;
      }
      if (selectedDay.id === 6) {
        rule.is_friday = true;
      }
      if (selectedDay.id === 7) {
        rule.is_saturday = true;
      }
    }
  }

  /**
   * @name getApplicableRules
   * @description Takes a set of time-related rules and returns any which are active during the requested range.
   * @param {type} start Description
   * @param {type} end Description
   * @param {type} rules Description
   * @return {type} Description
   */
  function getApplicableRules(start, end, rules) {
    // Performance improvement: filter out rules which end before 'start' and start after 'end'
    let results = [];
    let days = groupByDay(rules);

    for (let current = moment(start); current < end; current.add(1, 'day')) {
      let dayOfWeek = current.day();
      let firstSunday = moment(current).startOf('week');
      let endOfDay = moment(current).endOf('day');
      let currentRules = days[dayOfWeek];

      for (let i = 0; i < currentRules.length; i++) {
        let rule = currentRules[i];
        if (rule.start <= endOfDay &&
          (_.isUndefined(rule.end) || rule.end > current) &&
          !(firstSunday.diff(rule.first_sunday, 'weeks') % rule.weekly_frequency)) {
            if (results.indexOf(rule) === -1) {
              results.push(rule);
            }
          }
      }
    }
    return results;
  }

  // Takes multiple instances and 'merges' them when appropriate.
  // Instances are merged if the end of one coincides perfectly with the start of another.
  // The first instance gets the end and end_time of the second instance, and its length is updated.
  // More than two back-to-back instances will be chained into a larger instance.
  // The original array is not modified; a copy with the merged set is returned instead.
  /**
   * @name mergeConsecutive
   * @description description
   * @param {type} input Description
   * @return {type} Description
   */
  function mergeConsecutive(input) {
    let instances = _.cloneDeep(input);
    sort(instances);

    let output = [];
    for (let i = 0; i < instances.length;) {
      let first;
      let last;
      let endTime;
      let j = i;

      first = instances[i];
      do {
        last = instances[j++];
        endTime = last.end;
      }
      while (j < instances.length && (endTime.unix() ===
      instances[j].start.unix()));

      if (first !== last) {
        first.end = last.end;
        first.end_time = last.end_time;
        first.length = last.end.diff(first.start, 'minutes');
      }
      output.push(first);
      i = j;
    }
    return output;
  }

  /**
   * @name sort
   * @description Description
   * @param {type} items Description
   */
  function sort(items) {
    items.sort(function(a, b) {
      return a.start - b.start;
    });
  }

  // Returns all rules which overlap the specified date range based purely on start/end dates.
  // Rules may or may not have actual occurences during the date range; this is not calculated
  // in this function for the sake of performance.
  /**
   * @name getRulesInRange
   * @description description
   * @param {type} rules Description
   * @param {type} start Description
   * @param {type} end Description
   * @return {type} Description
   */
  function getRulesInRange(rules, start, end) {
    let results = [];
    for (let i = 0; i < rules.length; i++) {
      let rule = rules[i];
      if (rule.start < end && (_.isUndefined(rule.end) ||
      start < rule.end)) {
        results.push(rule);
      }
    }
    return results;
  }

  // Returns instances (with start and end moments) of all rules which take place,
  // in part or in full, between start and end.
  /**
   * @name generateRuleInstances
   * @description description
   * @param {type} rules Description
   * @param {type} start Description
   * @param {type} end Description
   * @return {type} Description
   */
  function generateRuleInstances(rules, start, end) {
    let results = [];

    // Filter out rules which don't even overlap this range
    let possibleRules = getRulesInRange(rules, start, end);

    // Step through the days, from start to end
    for (let current = moment(start); current <= end; current.add(1, 'day')) {
      let dateString = moment(current).format('YYYY-MM-DD[T]');
      let firstSunday = moment(current).startOf('week');
      let startTime =
      (current === start ? start : moment(current).startOf('day'));
      let endTime = moment(current).endOf('day');
      if (endTime > end) {
        endTime = end;
      }

      // Filter out rules which don't even overlap this day
      let todayRules = getRulesInRange(possibleRules, startTime, endTime);
      // Group possible matches by day
      let days = groupByDay(todayRules);
      // Filter out rules which don't happen on this day of the week
      todayRules = days[current.day()];

      for (let i = 0; i < todayRules.length; i++) {
        let rule = todayRules[i];

        let ruleStartTime = moment(dateString + rule.start_time);
        let ruleEndTime = moment(dateString + rule.end_time);
        if (ruleEndTime <= ruleStartTime) {
          ruleEndTime.add(1, 'day');
        }

        // TODO Confusing use of '!'
        if (startTime < ruleEndTime && ruleStartTime <= endTime && !(firstSunday.diff(rule.first_sunday, 'weeks') % rule.weekly_frequency) && (!rule.end || ruleEndTime <= rule.end)) {
          results.push({
            start: ruleStartTime,
            end: ruleEndTime,
            rule: rule,
            duration: ruleEndTime.diff(ruleStartTime, 'minutes')
          });
        }
      }
    }
    return results;
  }

  // Takes a set of rule instances and removes normal rules based on
  // the existence of exceptions or days off during the same time period.
  /**
   * @name filterExceptions
   * @description description
   * @param {type} instances Description
   * @return {type} Description
   */
  function filterExceptions(instances) {
    let dates = {};
    let results = [];

    // Group each rule instance by the day that it starts on and then by artist ID
    for (let i = 0; i < instances.length; i++) {
      let instance = instances[i];
      let rule = instance.rule;
      let start = instance.start;

      let date = moment(start).startOf('day').format('YYYY-MM-DD');
      let artistsToday = dates[date];
      if (!artistsToday) {
        artistsToday = dates[date] = {};
      }

      let artist = artistsToday[rule.artist];
      if (!artist) {
        artist = artistsToday[rule.artist] = {
          normal: [],
          exceptions: [],
          daysOff: []
        };
      }

      if (rule.is_off) {
        artist.daysOff.push(instance);
      } else if (rule.is_exception) {
        artist.exceptions.push(instance);
      } else {
        artist.normal.push(instance);
      }
    }

    // Go through every artist-grouped set of rules on every date
    for (let artistDate in dates) {
      if (Object.prototype.hasOwnProperty.call(dates, artistDate)) {
        let artists = dates[artistDate];
        for (let id in artists) {
          if (Object.prototype.hasOwnProperty.call(artists, id)) {
            let thisArtist = artists[id];

            // If the artist doesn't have a daysOff instance starting on that day
            // add any exceptions they have on that day if they exist, otherwise
            // add normal rules that exist on that day
            if (!thisArtist.daysOff.length) {
              results = results.concat(thisArtist.exceptions.length ?
              thisArtist.exceptions : thisArtist.normal);
            }
          }
        }
      }
    }
    return results;
  }

  // Gets first rule on the start date and last rule on the end date.
  // End date is optional; if omitted it will get the last rule on the start date.
  /**
   * @name getShopTimes
   * @description description
   * @param {type} rules Description
   * @param {type} start Description
   * @param {type} end Description
   * @return {type} Description
   */
  function getShopTimes(rules, start, end) {
    let startDayInstances = generateRuleInstances(rules, moment(start).startOf('day'), moment(start).endOf('day'));
    let endDayInstances = (end ? generateRuleInstances(rules, moment(end).startOf('day'), moment(end).endOf('day')) : startDayInstances);

    let earliest = findFirst(startDayInstances);
    let latest = findLast(endDayInstances);

    let interval = {
      earliest: (earliest ? earliest : {start: moment(start).endOf('day')}),
      latest: (latest ? latest : {end: moment(end ? end : start).endOf('day')})
    };

    return interval;
  }

  /**
   * @name calculateDuration
   * @description Calculate Duration given Hours and Minutes
   * @param {type} hours Description
   * @param {type} minutes Description
   * @return {type} Description
   */
  function calculateDuration(hours, minutes) {
    return (hours ? 60 * hours : 0) + (minutes ? minutes : 0);
  }

  /**
   * @name filterByDuration
   * @description Returns a new array containing all items with a 'length' of at least 'duration'
   * @param {type} items Description
   * @param {type} duration Description
   * @return {type} Description
   */
  function filterByDuration(items, duration) {
    let output = [];
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      if (item.length >= duration) {
        output.push(item);
      }
    }
    return output;
  }

  /**
   * @name findFirst
   * @description description
   * @param {type} instances Description
   * @return {type} Description
   */
  function findFirst(instances) {
    let earliest;
    for (let i = 0; i < instances.length; i++) {
      let instance = instances[i];

      if (!earliest || instance.start < earliest.start) {
        earliest = instance;
      }
    }
    return earliest;
  }

  /**
   * @name findLast
   * @description description
   * @param {type} instances Description
   * @return {type} Description
   */
  function findLast(instances) {
    let latest;
    for (let i = 0; i < instances.length; i++) {
      let instance = instances[i];

      if (!latest || instance.end > latest.end) {
        latest = instance;
      }
    }
    return latest;
  }

  // Takes a set of rules and returns an array of 7 arrays, corresponding to the rules that apply to each day, Sunday ([0]) through Saturday ([6])
  /**
   * @name groupByDay
   * @description description
   * @param {type} rules Description
   * @return {type} Description
   */
  function groupByDay(rules) {
    let days = [[], [], [], [], [], [], []];
    for (let i = 0; i < rules.length; i++) {
      let rule = rules[i];
      for (let j = 0; j < rule.days.length; j++) {
        days[rule.days[j].id].push(rule);
      }
    }
    return days;
  }

  return ScheduleUtilFactory;
});



// WEBPACK FOOTER //
// ./components/schedule/util/schedule-util.service.js